import { createElement } from "react"

import { HelpIcon } from "@/3514/assets"
import { type TCoachingSessionsModalSimpleProps as TReschedulesModalProps } from "@/3514/entities/coaching-sessions"
import { EModalId } from "@/3514/store/modal"

import assets from "./session-info.assets"
import {
    type _TSessionInfoRenderFunctionSharedExternalParams as TFunctionExternalParams,
    type _TSessionInfoRenderMessagesPropsFunctionInternalParams as TFunctionInternalParams,
    type _TSessionInfoMessageComponentProps as TMessageProps
} from "./session-info.types"

function renderSessionTypeMessageProps({ t }: TFunctionInternalParams & TFunctionExternalParams): TMessageProps {
    return {
        text: t("entities.sessions.accordion.message.alignment"),
        typeIcon: createElement(assets.ExtraPartyIcon, { width: 14, height: 13 }),
        helpIcon: null,
        isAccessible: false
    }
}

function renderRescheduleCountMessageProps({
    session,
    sessionsQueryKey,
    t,
    modalDispatcher,
    isAccordionExpanded
}: TFunctionInternalParams & TFunctionExternalParams): TMessageProps {
    return {
        text: t("entities.sessions.accordion.message.rescheduleCount", {
            count: session.rescheduleCount,
            context: session.rescheduleCount === 1 ? String("") : String("few")
        }),
        typeIcon: createElement(assets.RescheduledCountIcon),
        helpIcon: createElement(HelpIcon),
        isAccessible: isAccordionExpanded,
        ariaLabel: t("entities.sessions.modal.reschedules.opener.ariaLabel"),
        action: (): void =>
            modalDispatcher.showModal<TReschedulesModalProps>(EModalId.SessionReschedules, {
                sessionsQueryKey,
                sessionId: session.id
            })
    }
}

export default { renderSessionTypeMessageProps, renderRescheduleCountMessageProps }
